import React, {Fragment, useEffect, useState} from 'react';
import styles from './StaffDocuments.scss';
import lodash from 'lodash';
import {RecommendationMessage} from './../StudyExpectations';
import {STAFF_DOCUMENTS_RECOMMENDATIONS} from 'common/util/studyHelpers';
import {
    CardLabels,
    DisabledCardTooltip,
    CardExpectationDocuments,
} from './common/shareComponent';
import {UserCanUploadFiles} from 'common/permissions/components/actionButton';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {manageStudyExpectationsPredicate,} from 'common/permissions/studyPredicates';
import {Conditional} from 'common/components/layout';


export function StudyExpectationsStaffDocuments(props) {
    const {
        expectedStaffDocuments,
        binderId,
        openFilePicker,
        onError,
        onFile,
        setUploadedFileToExpectation,
        setTeamMemberIdUpload,
        studyStage,
        studyTeam,
        manageStudyExpectations
    } = props;

    if (lodash.isEmpty(expectedStaffDocuments)) {
        return <RecommendationMessage currentStage={studyStage} message={STAFF_DOCUMENTS_RECOMMENDATIONS}/>;
    }
    const staffCards = studyTeam.map((teamMember, index) => {
        if (!Object.prototype.hasOwnProperty.call(expectedStaffDocuments, teamMember.studyRoleId)) {
            return null;
        }
        const expectations = expectedStaffDocuments[teamMember.studyRoleId];
        const hasExpectationStatus = expectations.find(expectation => expectation.status.find(stat => stat.studyTeamMemberId === teamMember.id));
        if (!hasExpectationStatus) return null;
        return (
            <li key={index}
                className={styles.expectationCard}
                data-cy={'StaffDocuments' + index}
            >
                <CardTeamMember
                    teamMember={teamMember}
                />
                <CardExpectations
                    binderId={binderId}
                    onError={onError}
                    onFile={onFile}
                    expectations={expectedStaffDocuments}
                    teamMember={teamMember}
                    openFilePicker={openFilePicker}
                    setUploadedFileToExpectation={setUploadedFileToExpectation}
                    setTeamMemberIdUpload={setTeamMemberIdUpload}
                    manageStudyExpectations={manageStudyExpectations}
                />
            </li>
        );
    });

    return <ul className={styles.expectationCards}>{staffCards}</ul>;
}

export const CardTeamMember = ({ teamMember }) => {
    return (
        <Fragment data-cy="StaffDocuments-CardTeamMember">
            <p className={styles.teamMemberRole} data-cy="StaffDocuments-p">
                {teamMember.studyRole.name}
            </p>
            <h2
                className={styles.teamMemberName}
                data-cy="StaffDocuments-h2"
            >
                {teamMember.displayName}
            </h2>
        </Fragment>
    );
};

export const CardExpectations = (props) => {
    const {
        expectations,
        binderId,
        teamMember,
        openFilePicker,
        setUploadedFileToExpectation,
        setTeamMemberIdUpload,
        onError,
        onFile,
        manageStudyExpectations
    } = props;

    const [unfolded, setUnfolded] = useState(new Array(expectations[teamMember.studyRoleId].length)
        .fill(false));

    useEffect(() => {
        if (!!expectations[teamMember.studyRoleId] && expectations[teamMember.studyRoleId].length > 0) {
            setUnfolded(unfolded => {
                return expectations[teamMember.studyRoleId].reduce((acc, curr) => {
                    const filteredUploadedDocuments = filterUploadedDocuments(curr.uploaded || [], teamMember);
                    acc.push(!lodash.isEmpty(filteredUploadedDocuments));
                    return acc;
                }, []);
            });
        }
    }, [expectations[teamMember.studyRoleId]]);

    const setListItem = value => {
        setUnfolded(
            unfolded.map((unfold, index) => {
                return index === value
                    ? !unfold
                    : unfold;
            })
        );
    };

    const cards = expectations[teamMember.studyRoleId].map((expectation, index) => {
        const documentStatus = getDocumentStatus(expectation, teamMember);
        const documentAccess = expectation.documentAccess;
        const filteredUploadedDocuments = filterUploadedDocuments(expectation.uploaded || [], teamMember);
        const hasUploadedDocuments = !lodash.isEmpty(filteredUploadedDocuments);
        const filteredDocuments = filterDocuments(expectation, teamMember);
        const hasFiledDocuments = filteredDocuments.length > 0;
        const hasDocument = hasUploadedDocuments || hasFiledDocuments;
        const showCard = !lodash.isEmpty(documentStatus) &&
            (manageStudyExpectations || expectation.documentAccess);
        const cardClassNames = classnames({
            [styles.disabledListItem]: !documentAccess,
            [styles.expectationListItem]: documentAccess
        });

        return (
            <Conditional condition={showCard} data-cy="StaffDocuments-CardExpectations">
                <li className={cardClassNames} key={index} data-cy={'StaffDocuments-li-' + index}>
                    <div className={styles.expectationDetailsItem}>
                        <DisabledCardTooltip hasDocumentAccess={documentAccess}/>
                        <div className={styles.expectationDetails}>
                            <CardLabels
                                cardTitle={expectation.name}
                                cardStatus={documentStatus.status}
                            />
                            <CardControls
                                expectation={expectation}
                                teamMemberId={teamMember.id}
                                setUploadedFileToExpectation={setUploadedFileToExpectation}
                                setTeamMemberIdUpload={setTeamMemberIdUpload}
                                openFilePicker={openFilePicker}
                                unfolded={unfolded[index]}
                                onClick={() => setListItem(index)}
                            />
                        </div>
                    </div>
                    <Conditional condition={unfolded[index]}>
                        <CardExpectationDocuments
                            expectation={expectation}
                            binderId={binderId}
                            onError={onError}
                            onFile={onFile}
                            filteredUploadedDocuments={filteredUploadedDocuments}
                            filteredDocuments={filteredDocuments}
                            hasDocument={hasDocument}
                        />
                    </Conditional>
                </li>
            </Conditional>
        );
    });

    return <ul className={styles.expectationList} data-cy="StaffDocuments-ul"> {cards} </ul>;
};


export const CardControls = ({
    expectation,
    openFilePicker,
    setUploadedFileToExpectation,
    setTeamMemberIdUpload,
    teamMemberId,
    unfolded,
    onClick
}) => {
    const UploadIcon = () => (
        <i
            className={styles.upload}
            onClick={() => {
                setTeamMemberIdUpload(teamMemberId);
                setUploadedFileToExpectation(expectation);
                openFilePicker(expectation);
            }}
        >
            {'cloud_upload'}
        </i>
    );
    const SecuredUploadIcon = UserCanUploadFiles(UploadIcon);
    return (
        <div
            className={styles.cardControls}
            data-cy="StaffDocuments-CardControls"
        >
            <SecuredUploadIcon/>
            <p
                className={styles.foldedLabel}
                onClick={onClick}
                data-cy="StaffDocuments-onClick"
            >
                {unfolded ? 'Collapse' : 'Expand'}
            </p>
            <i
                className={styles.unfold}
                onClick={onClick}
                data-cy="StaffDocuments-i"
            >
                {unfolded ? 'unfold_less' : 'unfold_more'}
            </i>
        </div>
    );
};


export const filterUploadedDocuments = (uploaded, teamMember) => {
    return uploaded.filter(doc => doc.teamMemberId === teamMember.id);
};

export const filterDocuments = (expectation, teamMember) => {
    return lodash.isArray(expectation.documents) && expectation.documents.filter(document => document.teamMemberId === teamMember.id);
};

export const getDocumentStatus = (expectation, teamMember) => {
    return expectation.status.find(status => status.studyTeamMemberId === teamMember.id) || {};
};

export default connect(state => {
    const manageStudyExpectations = manageStudyExpectationsPredicate(state);
    return {
        manageStudyExpectations
    };
},
)(StudyExpectationsStaffDocuments);
